/* eslint-disable no-await-in-loop */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import {
  FaFile,
  FaFileAlt,
  FaFileCsv,
  FaFilePdf,
} from 'react-icons/fa';
import { getMyStatementFiles, getMyStatements } from '../../../../api/queries';
import H2 from '../../../../components/h2';
import SideNavItem from '../../../../components/sideNavItem';
import Spacer from '../../../../components/spacer';
import AppState from '../../../../store/appstate';
import StatementsTable from '../../../../components/statementsTable';

function Statements() {
  const { t } = useTranslation('other');
  return (
    <div className="flex flex-wrap">
      <div className="w-full bg-sentric-menu-gray lg:min-h-screen-minus-header sentric-shadow-left">
        <div className="mx-4 lg:mx-12 xl:mx-20 2xl:mx-40 my-6">
          <H2>{t('other:statements-header')}</H2>
          <Spacer />
          <StatementsTable />
        </div>
      </div>
    </div>
  );
}
export default Statements;
